<template>
  <div class="company-report-table-scroll">
    <slot />
  </div>
</template>

<style scoped>
.company-report-table-scroll {
  width: 100%;
  max-height: min(70vh, 720px);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.company-report-table-scroll :deep(table) {
  min-width: 100%;
  width: max-content;
}

.company-report-table-scroll :deep(thead th) {
  position: sticky;
  z-index: 1;
  background-color: #fff;
}

.company-report-table-scroll :deep(thead tr:first-child th) {
  top: 0;
}

.company-report-table-scroll :deep(thead tr:nth-child(2) th) {
  top: 2.25rem;
}
</style>
